import Api from '../Api';

export const getRoles = () => async dispatch => {
  const { data } = await Api.get('/roles');
  dispatch({
    type: 'FETCH_ROLES',
    payload: data,
  });
};

export const clearRoles = () => {
  return {
    type: 'CLEAR_ROLES',
  };
};

export const getRole = id => async dispatch => {
  const { data } = await Api.get(`/roles/${id}`);
  dispatch({
    type: 'FETCH_ROLE',
    payload: data,
  });
};

export const clearRole = () => {
  return {
    type: 'CLEAR_ROLE',
  };
};

export const getRoleIds = () => async dispatch => {
  const { data } = await Api.get('/roles/ids');
  dispatch({
    type: 'FETCH_ROLE_IDS',
    payload: data,
  });
};

export const clearRoleIds = () => {
  return {
    type: 'CLEAR_ROLE_IDS',
  };
};
